//messages.js
export default {
    quote_request_id: "Request #",
    request_date: "Request Date",
    comments: "Comments",
    edit_quote_request: "Edit Incoming RFQ",
    add_quote_request: "Add Incoming RFQ",
    delete_quote_request: "Delete Incoming RFQ",
    quote_requests: "Incoming RFQs",
    quote_request: "Incoming RFQ",
    delete_quote_request_confirm: "Are you sure you want to delete this estimate request?",

    /* quote_request_details */
    edit_quote_request_detail: "Edit Estimate Request Detail",
    add_quote_request_detail: "Add Estimate Request Detail",
    delete_quote_request_detail: "Delete Estimate Request Detail",
    quote_request_details: "Estimate Request Details",

    quote_request_link_object: "INCOMING RFQ",
    rfq_link_object: "RFQ",
    quote_link_object: "ESTIMATE",
    purchase_order_link_object: "PURCHASE ORDER",
    order_link_object: "ORDER",
    fe_invoice_link_object: "INVOICE",
    bill_link_object: "BILL",
    department: "Department",
    requests_for_estimates: "Estimate Requests",
};
